import React from 'react'

import { UnknownObject } from 'src/utils/reactTypes'

export const ToolIcon: React.FC<UnknownObject> = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4752 5.77496C13.3073 5.94631 13.2132 6.17669 13.2132 6.41663C13.2132 6.65657 13.3073 6.88694 13.4752 7.05829L14.9419 8.52496C15.1133 8.69292 15.3436 8.787 15.5836 8.787C15.8235 8.787 16.0539 8.69292 16.2252 8.52496L19.6811 5.06913C20.142 6.08772 20.2816 7.22259 20.0812 8.32251C19.8807 9.42243 19.3499 10.4352 18.5593 11.2257C17.7688 12.0163 16.756 12.5471 15.6561 12.7475C14.5562 12.948 13.4213 12.8084 12.4027 12.3475L6.06857 18.6816C5.70389 19.0463 5.20929 19.2512 4.69357 19.2512C4.17784 19.2512 3.68324 19.0463 3.31857 18.6816C2.95389 18.317 2.74902 17.8224 2.74902 17.3066C2.74902 16.7909 2.95389 16.2963 3.31857 15.9316L9.65273 9.59746C9.1918 8.57887 9.05224 7.444 9.25265 6.34408C9.45305 5.24416 9.98391 4.23144 10.7745 3.44087C11.565 2.65031 12.5778 2.11945 13.6777 1.91904C14.7776 1.71863 15.9125 1.8582 16.9311 2.31913L13.4844 5.76579L13.4752 5.77496Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
